import { render } from "./WhatsappConect.vue?vue&type=template&id=03b7b2c9"
import script from "./WhatsappConect.vue?vue&type=script&lang=js"
export * from "./WhatsappConect.vue?vue&type=script&lang=js"

import "./WhatsappConect.vue?vue&type=style&index=0&id=03b7b2c9&lang=css"

import exportComponent from "/deploy/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__